import { setVideoSource } from '../../utilities/set-video-source'
import { EnsureStylesheetLoaded } from '../../utilities/EnsureStylesheetLoaded'
import { setupInViewEvents } from '../../utilities/loader-events'
import { Logger } from '../../utilities/Logger'

const logger = new Logger('Inline videos')
const playEvent = 'video:in-view'
const pauseEvent = 'video:out-of-view'

const setupInlineVideo = function (video) {
  EnsureStylesheetLoaded().then(() => {
    let initialised = false
    const autoplay = video.attributes.autoplay !== undefined
    video.addEventListener(playEvent, function () {
      if (!initialised) {
        logger.log('loading inline video')
        setVideoSource(video, true)
        initialised = true
      }

      if (autoplay) {
        video.style.opacity = 1
        video.play()
      }
      logger.log('playing inline video')
    })

    video.addEventListener(pauseEvent, function () {
      video.pause()
      logger.log('pausing inline video')
    })

    setupInViewEvents(video, playEvent, pauseEvent)

    // Get associated play and pause controls.
    const videoId = video.attributes.id.value
    const playControls = document.querySelectorAll(`[aria-controls="${videoId}"][data-video-action="play"]`)

    for (const playBtn of playControls) {
      playBtn.addEventListener('click', () => {
        if (video.paused) {
          video.play()
          video.style.opacity = 1
          playBtn.setAttribute('aria-label', 'Pause video')
        } else {
          video.pause()
          playBtn.setAttribute('aria-label', 'Play video')
        }
      })
    }
  })
}

const setupInlineVideos = function (parent, setupRecheck = true) {
  const videos = parent.querySelectorAll('video[data-play-inline]')

  if (setupRecheck) {
    document.addEventListener('recheck-script', (e) => {
      setupInlineVideos(parent, false)
    })
  }

  for (const video of videos) {
    setupInlineVideo(video)
  }
}

export {
  setupInlineVideos
}
